import apiClient, { getAuthClient } from "./apiClient";

/**
 * Fetch all data with full details.
 * Uses authenticated client if user is logged in.
 * @returns {Promise} API response with full data and populated relations.
 */
export const getAllCollections = async () => {
  try {
    const client = getAuthClient();
    const response = await client.get(`/api/collections?populate=*`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

/**
 * Fetch all collection titles (including isPrivate flag).
 * @returns {Promise} API response with collection titles and privacy status.
 */
export const getCollections = async () => {
  try {
    const response = await apiClient.get(`/api/collections?fields[0]=title&fields[1]=isPrivate`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

/**
 * Fetch all images by collection name.
 * Uses authenticated client if user is logged in.
 * @param {string} collectionName - The name of the collection.
 * @returns {Promise} API response with images for the specified collection.
 */
export const getImagesByCollection = async (collectionName) => {
  try {
    const client = getAuthClient();
    const response = await client.get(
      `/api/collections?filters[title][$eq]=${collectionName}&populate=*`
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
